import {
	Dimension,
	FeatureEntity,
	PaymentProvider,
	PlanFamily,
	PlanStatus,
	SupportedFeature,
	SupportedPlan,
} from "@src/gql/graphql";

import type {
	FeatureState,
	MeteredFeatureState,
	MeteredPerEntityFeatureState,
	Plan,
} from "../plan-schemas";

export const defaultFeatureBooleanState = (
	feature: SupportedFeature,
): FeatureState => ({
	feature: feature,
	available: false,
});

export const defaultMeteredState = (
	feature: SupportedFeature,
): MeteredFeatureState => ({
	feature: feature,
	current: 0,
	quota: 5,
	dimension: Dimension.Quantity,
	available: false,
});

export const defaultMeteredPerEntityState = (
	feature: SupportedFeature,
): MeteredPerEntityFeatureState => ({
	feature: feature,
	current: 0,
	quota: 5,
	entity: FeatureEntity.Whiteboard,
	entityId: "",
	dimension: Dimension.Quantity,
	available: false,
});

export const defaultPlan = {
	plan: SupportedPlan.Starter,
	planFamily: PlanFamily.Starter,
	status: PlanStatus.Expired,
	provider: PaymentProvider.Illumi,
	renewsAt: null,
	external: {
		id: null,
		url: null,
		userId: null,
		terms: null,
	},
	trialEnd: null,
	features: [
		defaultMeteredState(SupportedFeature.DownloadAsMd),
		defaultMeteredState(SupportedFeature.DownloadAsPdf),
		defaultMeteredState(SupportedFeature.ConvertToNote),
		defaultFeatureBooleanState(SupportedFeature.ImageMaker),
		defaultFeatureBooleanState(SupportedFeature.ThinkingPartner),
		defaultFeatureBooleanState(SupportedFeature.CreateBoards),
		defaultMeteredState(SupportedFeature.CreateBoards),
		defaultMeteredPerEntityState(SupportedFeature.AddBoardEditors),
		defaultMeteredState(SupportedFeature.CreditsBudget),
	],
} satisfies Plan;
